import BaseStore from '@src/utils/store/base-store';
import DropDownMenuStore from './dropDownMenu/store';
import { computed, observable } from 'mobx';
import { jumpPage } from '@src/utils/common-util';
import { autobind } from 'core-decorators';
import copy from '@src/components/copy';
import BookModal from '@src/business-components/modals/book';
import BookModalStore from '@src/business-components/modals/book/store';
import useModal from '@src/utils/hooks/use-modal';
import message from '@src/components/common-message';
import $$tracker from '@src/tracker';
import { WORLD_VIEW_LINK } from '@src/constants/business';

export const NAVTYPE = {
  ANCHOR: 'anchor',
  Link: 'link',
  SELECT: 'select'
};

const linkMap = {
  '': 'index'
};

class NaviBarStore extends BaseStore {
  @computed
  get bgm() {
    return this.$globalStore.bgm;
  }

  dropDownMenuStore = new DropDownMenuStore();

  @observable isSticky = false;

  @observable
  navList = [
    {
      type: NAVTYPE.Link,
      anchor: '#root',
      link: '',
      title: '首页'
    },
    {
      type: NAVTYPE.Link,
      link: 'news-list',
      title: '新闻资讯'
    },
    {
      type: NAVTYPE.SELECT,
      title: '游戏介绍',
      childs: [
        {
          title: '游戏玩法',
          link: 'game-play'
        },
        {
          title: '机兵介绍',
          link: 'mecha-list'
        },
        {
          title: '王牌档案',
          link: 'mecha-unit-list',
          tracker: () => {
            $$tracker.clickTzjjs();
          }
        }
      ]
    },
    {
      type: NAVTYPE.SELECT,
      title: '作战资料',
      childs: [
        {
          title: '边缘战场',
          link: 'map'
        },
        {
          title: '王牌序列',
          link: 'map-wpxl'
        },
        {
          title: '风暴行动',
          childs: [
            {
              title: '玛什马克',
              link: 'https://mechabreak.seasungames.cn/zt/msmk/index.html#/',
              isHref: true
            }
          ]
        },
        {
          title: '壁纸',
          link: 'wallpaper',
          tracker: () => {
            $$tracker.clickBz();
          }
        }
      ]
    },
    {
      type: NAVTYPE.Link,
      title: '世界观',
      link: WORLD_VIEW_LINK,
      isHref: true,
      tracker: () => {
        $$tracker.clickSjg();
      }
    },
    {
      type: NAVTYPE.SELECT,
      title: '社区活动',
      childs: [
        {
          title: '直播掉宝',
          link: 'https://mechabreak.seasungames.cn/p/zt/live/index.html',
          isHref: true
        },
        {
          title: '造型排行',
          link: 'https://mechabreak.seasungames.cn/p/zt/2025/07/16/styling-ranking/index.html',
          isHref: true,
          tracker: () => {
            $$tracker.clickZXPH();
          }
        },
        {
          title: '客服中心',
          link: 'https://gm-mobile.xoyo.com/app/h5/jxj/zh-CN/index',
          isHref: true
        },
        {
          title: '王牌计划',
          link: 'https://mechabreak.seasungames.cn/zt/projectace/index.html#/',
          isHref: true
        }
      ]
    },
    {
      type: NAVTYPE.SELECT,
      title: '礼包购买',
      childs: [
        {
          title: '典藏礼盒',
          link: 'https://mechabreak.seasungames.cn/p/zt/2025/03/21/market/index.html',
          isHref: true,
          tracker: () => {
            $$tracker.clickDclh();
          }
        }
      ]
    }
  ];

  /**
   * 跳转页面
   * @param link 路由链接
   * @param isHref 是否为外链
   * @param toast 点击提示
   */
  toPage = (link, isHref, toast, tracker) => {
    if (toast) {
      message.info(toast);
      return;
    }

    if (tracker) {
      tracker();
    }

    const htmlLink = linkMap[link] || link;
    if (isHref) {
      window.open(link);
    } else if (!IS_DEV_ENV) {
      const url = `${htmlLink}.html`;
      jumpPage(url, '#/');
    } else {
      this?.redirect('/' + link);
    }
  };

  @autobind
  onCopyLink() {
    const { isSupport } = copy(window.location.href, {
      autoDisplayUnsupportedAlert: false,
      autoDisplaySupportedAlert: false
    });
    if (isSupport) {
      message.success('已成功复制链接');
    } else {
      message.info('由于您的设备不兼容, 请手动长按复制');
    }
  }

  // 登录
  login = () => {
    const { isDownloadStage } = this.$globalStore;
    if (isDownloadStage) {
      super.login({
        onLoginSuccess: e => {
          const { account } = e;
          this.$globalStore.accountInfo = account;
        }
      });
    } else {
      $$tracker.clickLjyy3();
      this.bookModal.open();
    }
  };

  // 退出登录
  exitAccount = () => {
    const { authServise } = this.$globalStore;
    authServise.exitAccount();
  };

  @autobind
  toDownloadPage() {
    $$tracker.clickDownload2();
    this.toPage('download', false);
  }

  // 预约弹窗
  bookModal = null;

  bookModalStore = new BookModalStore();

  use() {
    super.use();

    this.bookModal = useModal(BookModal, { store: this.bookModalStore });
  }
}

export default NaviBarStore;
